import {createSelector} from '@ngrx/store';

import * as fromDistrictsReducer from './districts.reducer'
import {AppState} from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromDistrictsReducer.districtsesFeatureKey]);

export const selectAllDistricts = createSelector(currentState, fromDistrictsReducer.selectAll);

export const selectTotalDistricts = createSelector(currentState, fromDistrictsReducer.selectTotal);

export const selectModifiedDistricts = createSelector(selectAllDistricts, (districts) => {
  return districts.map((district) => {
    return {
      ...districts
    };
  });
});
